import React from "react";
import ReactEChartsCoreRaw from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";

// Module interop fallback for React 19 / Vite
const ReactEChartsCore = (ReactEChartsCoreRaw as any).default || ReactEChartsCoreRaw;

import { LineChart, BarChart, PieChart } from "echarts/charts";
import { GridComponent, TooltipComponent, TitleComponent, LegendComponent, DataZoomComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([LineChart, BarChart, PieChart, GridComponent, TooltipComponent, TitleComponent, LegendComponent, DataZoomComponent, CanvasRenderer]);

export interface BaseChartProps {
	option: echarts.EChartsCoreOption;
	style?: React.CSSProperties;
	className?: string;
	notMerge?: boolean;
	lazyUpdate?: boolean;
	onEvents?: Record<string, Function>;
}

export const BaseChart: React.FC<BaseChartProps> = ({
	option,
	style = { height: "100%", width: "100%" }, // Default to 100% full-container sizing
	className,
	notMerge = true, // Default to true so chart data updates cleanly
	lazyUpdate = true,
	onEvents,
}) => {
	return (
		<ReactEChartsCore
			echarts={echarts}
			option={option}
			style={style}
			className={className}
			notMerge={notMerge}
			lazyUpdate={lazyUpdate}
			onEvents={onEvents}
		/>
	);
};
